/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
import { User } from './User';
const FailedToSendEmailExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['allUsers', /* #__PURE__ */ codecArray(User), 'all_users'],
    ['failedUsers', /* #__PURE__ */ codecArray(User), 'failed_users'],
]), BaseError);
export class FailedToSendEmailException extends BaseError {
    static decode(input) {
        return FailedToSendEmailExceptionParser.decode(input).map(res => new FailedToSendEmailException(res));
    }
    static unsafeDecode(input) {
        return FailedToSendEmailException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FailedToSendEmailExceptionParser.encode(data);
    }
    static schema() {
        return FailedToSendEmailExceptionParser.schema();
    }
}
